import { Dispatch } from 'redux';
import { getMidYearEnrollmentInfo, postMidYearEnrollment } from '../../../../global/ducks/mlps-api';
import { ProcessingStatus } from '../../../annual-enrollment/models/annual-enrollment-models';
import { MidYearEnrollment, MidYearEnrollmentFormValue } from './mid-year-model';
import { setMidYearEnrollment } from './mid-year-slices';
import { YesNoIndicators } from '../../../../global/models/api-model';
import { AbandonAction, DeleteAction } from '../../../annual-enrollment/components/annual-enrollment-admin-confirmation';

export function deleteWorkflow(dispatch: Dispatch<any>, guid: string, midYear: MidYearEnrollment, groupId: number) {
	const abandonPayload = {
		form_info: {
			change_id: midYear?.form_info?.change_id,
			change_id_signature: midYear?.form_info?.change_id_signature,
			workflow_action: 'Delete',
		},
	};

	dispatch(postMidYearEnrollment(guid, groupId, abandonPayload, (response) => {
		if (response?.api_response?.status === 'OK') {
			dispatch(dispatch(setMidYearEnrollment(response)));
		}
	}));
}


export function fetchMidYearInfo(dispatch: Dispatch<any>, guid: string, groupId: number) {

	dispatch(getMidYearEnrollmentInfo(groupId, guid, 0, (getResponse) => {

		if (getResponse?.form_record?.processing_status === ProcessingStatus.Active && getResponse?.form_info?.available_workflow_actions?.Abandon) {
			deleteWorkflow(dispatch, guid, getResponse, groupId);
		} else {
			dispatch(setMidYearEnrollment(getResponse));
		}
	}));

}

const getFormatedDate = (date: string) => {
	return date ? new Date(date).toISOString().slice(0, 10) : '';
};

export const submitMidYearEnrollment = (dispatch: Dispatch<any>, formValue: MidYearEnrollmentFormValue, midYearEnrollment: MidYearEnrollment, guid: string, groupId: number) => {

	const dateOfQualifying = getFormatedDate(formValue.date_of_qualifying_event);

	const dependents = midYearEnrollment.eligible_dependents;

	const dependentsPayload = {};
	for (let i = 0; i < dependents?.length; i += 1) {
		const dependentGuid = dependents[i]?.person._guid;

		dependentsPayload[dependentGuid] = {
			M: formValue.M.includes(dependentGuid) && !formValue.medicalPlanTerminateDate ? YesNoIndicators.Yes : YesNoIndicators.No,
			D: formValue.D.includes(dependentGuid) && !formValue.dentalPlanTerminateDate ? YesNoIndicators.Yes : YesNoIndicators.No,
		};
	}

	const verifyPayload = {
		form_info: {
			change_id: midYearEnrollment?.form_info?.change_id,
			change_id_signature: midYearEnrollment?.form_info?.change_id_signature,
			workflow_action: 'Verify',
		},
		global_edited: {
			memo: formValue.memo,
			special_requests: formValue.specialRequests,
			extenuating_circumstances: formValue?.extenuatingCircumstances,
			date_of_qualifying_event: dateOfQualifying,
			user_acknowledgement: YesNoIndicators.Yes,
		},
		enrollments_edited: {
			M: formValue.medicalPlan === '' ? null : [{
				code: formValue.medicalPlan,
				effective_date: getFormatedDate(formValue.medicalPlanEffectiveDate),
				termination_date: getFormatedDate(formValue.medicalPlanTerminateDate),
				account_nbr: formValue.medicalPlanBillingAccount,
			}],
			D: formValue.dentalPlan === '' ? null : [{
				code: formValue.dentalPlan,
				effective_date: getFormatedDate(formValue.dentalPlanEffectiveDate),
				termination_date: getFormatedDate(formValue.dentalPlanTerminateDate),
				account_nbr: formValue.dentalPlanBillingAccount,
			}],
			G: formValue.groupLifePlan === '' ? null : [{
				code: formValue.groupLifePlan,
				effective_date: getFormatedDate(formValue.groupLifePlanEffectiveDate),
				termination_date: getFormatedDate(formValue.groupLifePlanTerminateDate),
				volume: formValue.groupLifePlanVolume,
				account_nbr: formValue.groupLifePlanBillingAccount,
			}],
			//S: formValue.supplementalLifePlan === '' ? null : [{
			//	code: formValue.supplementalLifePlan,
			//	effective_date: getFormatedDate(formValue.supplementalLifePlanEffectiveDate),
			//	termination_date: getFormatedDate(formValue.supplementalLifePlanTerminateDate),
			//	volume: formValue.supplementalLifePlanVolume,
			//	account_nbr: formValue.supplementalLifePlanBillingAccount,
			//}],
			//P: formValue.supplementalSpousePlan === '' ? null : [{
			//	code: formValue.supplementalSpousePlan,
			//	effective_date: getFormatedDate(formValue.supplementalSpousePlanEffectiveDate),
			//	termination_date: getFormatedDate(formValue.supplementalSpousePlanTerminateDate),
			//	volume: formValue.supplementalSpousePlanVolume,
			//	account_nbr: formValue.supplementalSpousePlanBillingAccount,
			//}],
			L: formValue.longTermDisabilityPlan === '' ? null : [{
				code: formValue.longTermDisabilityPlan,
				effective_date: getFormatedDate(formValue.longTermDisabilityPlanEffectiveDate),
				termination_date: getFormatedDate(formValue.longTermDisabilityPlanTerminateDate),
				account_nbr: formValue.longTermDisabilityPlanBillingAccount,
			}],
			W: formValue.shortTermDisabilityPlan === '' ? null : [{
				code: formValue.shortTermDisabilityPlan,
				effective_date: getFormatedDate(formValue.shortTermDisabilityPlanEffectiveDate),
				termination_date: getFormatedDate(formValue.shortTermDisabilityPlanTerminateDate),
				account_nbr: formValue.shortTermDisabilityPlanBillingAccount,
			}],
			U: formValue.unemploymentInsurancePlan === '' ? null : [{
				code: formValue.unemploymentInsurancePlan,
				effective_date: getFormatedDate(formValue.unemploymentInsurancePlanEffectiveDate),
				termination_date: getFormatedDate(formValue.unemploymentInsurancePlanTerminateDate),
				account_nbr: formValue.unemploymentInsurancePlanBillingAccount,
			}],
		},
		dep_enrollments_edited: dependentsPayload,
	};

	dispatch(postMidYearEnrollment(guid, groupId, verifyPayload, (verifyResponse) => {
		const verifyResponseInfo = verifyResponse as MidYearEnrollment;

		if (verifyResponseInfo?.api_response?.status === 'OK' && verifyResponseInfo?.processing_messages?.errors?.length < 1) {
			const submitPayload = {
				form_info: {
					change_id: verifyResponseInfo?.form_info?.change_id,
					change_id_signature: verifyResponseInfo?.form_info?.change_id_signature,
					workflow_action: verifyResponseInfo?.form_info?.available_workflow_actions?.Process ? 'Process' : 'Submit',
				},
				global_edited: verifyPayload.global_edited,
				enrollments_edited: verifyPayload.enrollments_edited,
				dep_enrollments_edited: dependentsPayload,
			};

			dispatch(postMidYearEnrollment(guid, groupId, submitPayload, (submitResponse) => {
				const submitResponseInfo = submitResponse as MidYearEnrollment;
				//reposnse from submit it's not returning extenuating_circumstances so it will be included
				//for review page
				submitResponseInfo.global_edited.extenuating_circumstances = verifyPayload.global_edited.extenuating_circumstances;

				dispatch(setMidYearEnrollment(submitResponseInfo));

			}));
		} else {
			dispatch(setMidYearEnrollment(verifyResponseInfo));

		}
	}));

};



export const deleteFormClick = (dispatch: Dispatch<any>, guid: string, groupId: number, midYearState: MidYearEnrollment, redirectHandler: () => void, closeModalHandler: () => void) => {
	dispatch(postMidYearEnrollment(
		guid,
		groupId,
		{
			form_info: {
				change_id: midYearState?.form_info?.change_id,
				change_id_signature: midYearState?.form_info?.change_id_signature,
				workflow_action: midYearState?.form_info?.available_workflow_actions.Abandon ? AbandonAction : DeleteAction,
			},
		},
		() => {
			dispatch(getMidYearEnrollmentInfo(groupId, guid, 0, (response) => {
				dispatch(setMidYearEnrollment(response));
				redirectHandler();
			}));

		}));
	closeModalHandler();
};